import { useEffect } from 'react';
import { useLazyGetNotificationsDMQuery, useUpdateNotificationsDMMutation } from '@/store/api/notificationApi';
import { useParams } from 'react-router-dom';
import { useToast } from '@/hooks/shared/use-toast';

export const useUserNotificationMethods = () => {
  const { toast } = useToast();
  const { userId } = useParams<{ userId: string }>();
  const [updateDeliveryMethods, { isLoading: isUpdatingDeliveryMethods }] = useUpdateNotificationsDMMutation();
  const [fetchDeliveryMethods, { data: notificationMethods, isLoading, isFetching }] = useLazyGetNotificationsDMQuery();

  const updateNotificationDeliveryMethods = async (payload: any) => {
    try {
      await updateDeliveryMethods(payload).unwrap();

      toast({
        variant: 'success',
        title: 'Success',
        description: 'Delivery method preferences have been updated',
      });
    } catch (error: any) {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: `Failed to update delivery method preferences`,
      });
    }
  };

  useEffect(() => {
    if (userId) fetchDeliveryMethods({ uids: userId }, true);
  }, [userId, fetchDeliveryMethods]);

  return {
    notificationMethods: notificationMethods || [],
    updateNotificationDeliveryMethods,
    isLoadingNotificationMethods: isLoading || isFetching,
    isUpdatingNotificationMethods: isUpdatingDeliveryMethods,
  };
};
